import styled from "styled-components";

export const HeaderContainer = styled.header`
  display: flex;
  flex-direction: column;
  span {
    font-size: 0.75rem;
    color: #5e5e5e;
    margin-bottom: 22px;
    color: ${({ theme }) => theme.colors.gray};

    display: flex;
    align-items: center;
  }

  h1 {
    font-size: 1.4375rem;
    margin-bottom: 12px;
    color: ${({ theme }) => theme.colors.blue};
  }

  h2 {
    font-size: 0.9375rem;
    margin-bottom: 18px;
    color: ${({ theme }) => theme.colors.gray};
    line-height: 30px;
    font-weight: 400px;
  }

  p {
    color: ${({ theme }) => theme.colors.black};
    font-weight: bold;
  }

`;
